'use strict';

import { BaseElement } from '../../../../interfaces/BaseElement';
import { changeLangToCurrent } from '../../../langSwitcher/langSwitcher';
import ObjectAssignDeep from 'object-assign-deep';
import gsap from 'gsap';
import { DreamsPreloader } from '../../DreamsPreloader';

const DEFAULT_PARAMS = {
  textDuration: 3,
  textFadeDuration: 0.5,
  textCount: 0
};


export class SubPreloader {
  constructor (parent) {
    this.parent = parent;
    this.settings = ObjectAssignDeep(DEFAULT_PARAMS,config.features.subPreloader,{});
    this.container = new BaseElement('span')
      .addClass('sub-preloader')
      .appendTo(this.parent)
      .DOMElement;

    new DreamsPreloader(this.container).show();

   this.subTexts = new BaseElement('span')
     .addClass('sub-preloader__texts')
     .appendTo(this.container)
     .DOMElement;
  }

  createSubTexts() {
    if (this.settings.textCount === 0) return;

    const duration = this.settings.textDuration;
    const fadeDuration = this.settings.textFadeDuration;
    const textCount = this.settings.textCount;

    this.tl = gsap.timeline({
      paused: true,
      onComplete: () => this.subTexts.remove()});

    for (let i = 1; i <= textCount; i++) {
      const childTl = gsap.timeline();
      const text = new BaseElement('span')
          .addClass('sub-preloader__text')
        .innerHtml(changeLangToCurrent(`subLoaderTxt${i}`))
        .appendTo(this.subTexts)
        .DOMElement;

      const animationIn = gsap.to(text,{
        opacity: 1,
        duration: fadeDuration
      });

      const animationOut = gsap.to(text,{
        opacity: 0,
        duration: fadeDuration
      });

      childTl.add(animationIn,0);
      childTl.add(animationOut,duration - fadeDuration);
      this.tl.add(childTl,duration * (i-1));
    }
    this.tl.play(0);
  }

  remove() {
    this.tl?.kill();
    this.tl = null;
    this.container.remove();
  }
}
